import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class OfferOrderDetails<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: string;
  /** Alias: sumPurchasePrice */
  sumPurchasePrice?: number;
  /** Alias: dbPercent */
  dbPercent?: number;
  /** Alias: netValueMainCurrency */
  netValueMainCurrency?: string;
  /** Alias: grossValueMainCurrency */
  grossValueMainCurrency?: string;

  __typename?: string;
}

const fields: FieldDefinitions<OfferOrderDetails> = {
  id: {
    alias: 'code',
  },
  sumPurchasePrice: {
    alias: 'sumPurchasePrice',
  },
  dbPercent: {
    alias: 'dbPercent',
  },
  netValueMainCurrency: {
    alias: 'netValueMainCurrency',
  },
  grossValueMainCurrency: {
    alias: 'grossValueMainCurrency',
  },
  __typename: {
    alias: '__typename',
  },
};

export const offerOrderDetailsEntityDefinition: EntitiyDefinition<OfferOrderDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'OfferOrderDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
